import axios from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export type LicensingSettings = {
  showSubscription: boolean;
  showBinary: boolean;
  showSourceCode: boolean;
};

const API_BASE_URL =
  process.env.NEXT_PUBLIC_API_BASE_URL || process.env.NEXT_PUBLIC_REACT_APP_BASE_URL1 || '';

export async function fetchLicensingSettings(): Promise<LicensingSettings> {
  const res = await axios.get(`${API_BASE_URL}/licensing`);
  // The backend returns { success, data }
  const payload = res.data?.data ?? res.data;
  return {
    showSubscription: Boolean(payload?.showSubscription),
    showBinary: Boolean(payload?.showBinary),
    showSourceCode: Boolean(payload?.showSourceCode),
  };
}

export async function updateLicensingSettings(
  payload: Partial<LicensingSettings>
): Promise<LicensingSettings> {
  const token = typeof window !== 'undefined' ? localStorage.getItem('auth-token') : undefined;
  const res = await axios.patch(`${API_BASE_URL}/licensing`, payload, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  const data = res.data?.data ?? res.data;
  return {
    showSubscription: Boolean(data?.showSubscription),
    showBinary: Boolean(data?.showBinary),
    showSourceCode: Boolean(data?.showSourceCode),
  };
}

export const LICENSING_SETTINGS_QUERY_KEY = ['licensing-settings'];

// Shared across every component that reads licensing settings (BookPageHome,
// LicensingOptions, ...) so they hit the API once and share one cached result
// instead of each mounting its own fetch.
export function useLicensingSettings() {
  return useQuery(LICENSING_SETTINGS_QUERY_KEY, fetchLicensingSettings, {
    staleTime: 60_000,
  });
}

export function useInvalidateLicensingSettings() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries(LICENSING_SETTINGS_QUERY_KEY);
}
